export default __webpack_public_path__ + "static/media/663.6b512dfb.png";